<template>
  <div class="step-item">
    <div
      class="step-item__icon-wrapper"
      :class="{ 'step-item__icon-wrapper--monthly': variant === 'monthly' }"
    >
      <img :src="stepIcon" class="step-item__icon" />
    </div>
    <div class="step-item__text-wrapper">
      <h3 class="step-item__title">{{ step.day }}</h3>
      <p class="step-item__text">{{ step.text }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getImage } from '@/models/onboarding'
import type { TrialStep } from '@/models/onboarding.types'
import { computed } from 'vue'

const props = defineProps<{
  step: TrialStep
  variant: 'annual' | 'monthly'
}>()

const stepIcon = computed(() => {
  if (props.variant === 'monthly') {
    return getImage(props.step.icon.replace('.svg', '-monthly.svg'))
  }
  return getImage(props.step.icon)
})
</script>

<style lang="scss" scoped>
.step-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background-color: $c-white;
  border-radius: 16px;
  padding: 12px 16px;
  width: 100%;
  text-align: left;
  box-shadow: 0px 2.275px 9.1px 0px rgba(0, 0, 0, 0.11);
  z-index: 1;
  position: relative;

  &:last-child {
    &::after {
      display: none;
    }
  }

  &__title {
    font-size: 18px;
    line-height: 28px;
    color: $c-black-15;
    font-weight: 500;
  }

  &__text {
    color: $c-black-3;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.28px;
  }

  &__icon {
    width: 28px;
    height: 28px;
  }

  &__icon-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 72px;
    height: 66px;
    flex-shrink: 0;
    border-radius: 12px;
    background-color: #{rgba($c-blue-4, 0.1)};

    &--monthly {
      background-color: $c-bg !important;
    }
  }

  &:nth-of-type(2) {
    .step-item__icon-wrapper {
      background-color: #{rgba($c-yellow, 0.2)};
    }
  }
}
</style>
